/**
 * MenuSearchContainer component.
 */
import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the menu search container.
 */
interface Props {
  collapse: boolean;
}

/**
 * Styled container for the menu search.
 */
const MenuSearchContainer = styled.div<Props>`
  cursor: ${({ collapse }) => (collapse ? 'default' : 'pointer')};
  filter: ${({ collapse }) =>
    collapse ? 'drop-shadow(0px 0px 4px #000000)' : 'none'};
  left: ${({ collapse }) => (collapse ? 8 : 40) * ScreenUtils.widthRatio}px;
  position: absolute;
  top: ${145 * ScreenUtils.widthRatio}px;
`;

export default withOpacity(MenuSearchContainer);
